import {Fragment} from "preact";

const GenericError = () => {
    return (
        <Fragment>
            <div className={"w-screen flex flex-row justify-center items-center"}>
                <h1 className="text-2xl font-bold py-24">
                    Ops, algo deu errado! :(
                </h1>
            </div>
        </Fragment>
    )
}

export default GenericError;
